<div class="sustainable catalog__columnFilters">
  <vc-sprite-icons name="sustainable-leaf" class="sustainable__icon"></vc-sprite-icons>
  <span class="sustainable__title" i18n="@@REGULAR_FILTER_DS.SUSTAINABLE_LEAF.CTA"
    ><span lang="en">Sustainable</span></span
  >
  <ng-container *ngIf="isMobile; else openPopinDesktop">
    <label class="sustainable__btn vc-text-s" for="openSustainableDS" (click)="openMobileSustainable()">
      <span i18n="@@CATALOG.SEO_CONTENT.BUTTON.EXPAND" *ngIf="!sustainablePanelOpen">See more</span>
      <span i18n="@@CATALOG.SEO_CONTENT.BUTTON.SHRINK" *ngIf="sustainablePanelOpen">See less</span>
    </label>
    <input type="checkbox" id="openSustainableDS" class="sustainable__box" />
    <p class="sustainable__more vc-text-s" i18n="@@INFO_LEAF_MODAL.SUSTAINABLE_LEAF.TEXT2">
      This only shows items in your region, so your orders will have shorter distances to travel to reach your wardrobe!
    </p>
  </ng-container>
  <ng-template #openPopinDesktop>
    <button
      class="sustainable__btn vc-text-s"
      (click)="openDesktopSustainable()"
      i18n="@@HELPER_MESSAGE.SUSTAINABLE_LEAF.CTA"
    >
      Learn more
    </button>
  </ng-template>
</div>
